import { MutableRefObject, useEffect, useState } from "react";
import { BACKGROUND_EFFECT_TYPE } from "../data/interfaces";
import { getLandingContainer } from "../views/utils/getLandingContainer";

export function useIScroll( 
    ref: MutableRefObject<null> | HTMLDivElement | any, 
    effect: BACKGROUND_EFFECT_TYPE | undefined,
    zeroScroll: number = 0
): number {
    const [container, setContainer] = useState<Element>( getLandingContainer() )
    const [scroll, setScroll] = useState<number>( 0 )
    const onscrollHandler = () => {
        setScroll( getIScroll( ref, zeroScroll) )
    }
    
    useEffect(() => {
        setContainer( getLandingContainer() ) 
    }, [ ])    
    useEffect(() => { 
        if( !!container && !!effect && effect !== BACKGROUND_EFFECT_TYPE.NONE) { 
            container.addEventListener("scroll", onscrollHandler) 
            return () => { 
                container.removeEventListener("scroll", onscrollHandler) 
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [container, zeroScroll])
    return scroll
}

export const getIScroll = ( 
    ref: MutableRefObject<null> | HTMLDivElement | any,
    zeroScroll: number = 0 
): number => {
    try 
    {
        const lScroll = getLandingContainer().scrollTop
        const element = !!ref?.current ? ref.current : null
        if(!!element){
            const iScroll = ( element as HTMLDivElement ).getBoundingClientRect().top
            const defScroll = lScroll - iScroll - zeroScroll       
            return( defScroll )
        } 
    } 
    catch (e) 
    {            
        console.log(e)            
    }
    return 0
}